import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import ShallowRenderedComponent from '../../base/ShallowRenderedComponent';
import { checkPureObject } from '../../../utils/func';
import { IconContext } from 'react-icons';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

class GenericSelector extends ShallowRenderedComponent {

    static propTypes = {
        idKey: PropTypes.string,
        titleKey: PropTypes.string,
        multiselect: PropTypes.bool,
        selectionType: PropTypes.string,
        selections: PropTypes.any,
        onChange: PropTypes.func,
        id: PropTypes.string,
        options: PropTypes.any,
        className: PropTypes.string,
        allSelections: PropTypes.object,
		onUpdate: PropTypes.func,
        selectorTitle: PropTypes.string,
        showCountInTitle: PropTypes.bool,
        atLeastOne: PropTypes.bool,
		popoverStaysOpened: PropTypes.bool
    }

    onCheckIfSelected = (itemToCheck, isSecondary = false) => {
        const { selectionType, idKey, multiselect, selections, secondarySelections, value, withInputBox } = this.props;
        let proppedSelections = !_.isUndefined(selections) ? selections : value;
        let proppedSecondarySelections = !_.isUndefined(secondarySelections) ? secondarySelections : value;
        if (isSecondary) proppedSelections = proppedSecondarySelections;
        if (selectionType=='id'&&!multiselect) {
			if (withInputBox) {
				return true;
			}
            return proppedSelections == itemToCheck[idKey];
        } else if (selectionType=='id'&&withInputBox&&multiselect) {
			let selectionsToCheck = _.isObject(selections) ? { ...selections } : [];
			return itemToCheck[idKey] in selectionsToCheck;
		} else if (selectionType=='id2') {
            return proppedSelections == itemToCheck[idKey];
        } else if (selectionType=='id'&&multiselect) {
            let selectionsToCheck = _.isArray(proppedSelections) ? [ ...proppedSelections ] : [];
            return _.includes(selectionsToCheck, itemToCheck[idKey])
        } else if (selectionType=='object'&&multiselect) {
            return _.findIndex(proppedSelections, [idKey, itemToCheck[idKey]])>=0;
        } else if (selectionType=='object'&&!multiselect) {
            return proppedSelections?.[idKey] == itemToCheck[idKey];
        } else if (selectionType=='boolean') {
			return !!proppedSelections;
		}
    }

    onChange = itemsSelected => {
        const { selectionType, idKey, multiselect, selections, onChange, atLeastOne, value, withInputBox, inputType } = this.props;
        const proppedSelections = !_.isUndefined(selections) ? selections : value;
		if (selectionType=='boolean'){
			onChange(itemsSelected);
		} else if (selectionType=='id'&&!multiselect) {
            if (proppedSelections==itemsSelected[idKey]) {
                if (atLeastOne) {
                    onChange(itemsSelected[idKey]);
                } else {
                    onChange(undefined);
                }
            } else {
                onChange(itemsSelected[idKey]);
            }
        } else if (selectionType=='id'&&withInputBox) {
			let updatedSelections = _.isNull(selections) || _.isUndefined(selections)  ? {} : { ...selections };
			if (multiselect) {
				if (itemsSelected[0] in updatedSelections && updatedSelections[itemsSelected[0]] == itemsSelected[1]) {
					delete updatedSelections[itemsSelected[0]]
				} else if (inputType=='threshold') {
					updatedSelections[itemsSelected[0]] = _.toInteger(itemsSelected[1]);
				} else {
					updatedSelections[itemsSelected[0]] = itemsSelected[1];
				}
			}
			else {
				if (itemsSelected in selections) {
					delete updatedSelections[itemsSelected[0]];
				} else {
					updatedSelections[itemsSelected[0]] = itemsSelected[1];
				}
			}
			onChange(updatedSelections);
		} else if (selectionType=='id'&&multiselect) {
            let updatedSelections = _.isArray(proppedSelections) ? [ ...proppedSelections ] : [];
            if (_.includes(updatedSelections, itemsSelected[idKey])) {
                updatedSelections = _.filter(updatedSelections, item => item !== itemsSelected[idKey]);
            } else {
                updatedSelections = [ ...updatedSelections, itemsSelected[idKey]];
            }
            onChange(updatedSelections);
        } else if (selectionType=='id2') {
            if (proppedSelections==itemsSelected[idKey]) {
                onChange([undefined,undefined]);
            } else {
                onChange([itemsSelected[idKey], itemsSelected['id2']]);
            }
        } else if (selectionType=='file') {
            onChange(itemsSelected);
        } else if (selectionType=='object'&&!multiselect) {
            onChange(itemsSelected);
        } else if (selectionType=='object'&&multiselect) {
            let updatedSelections = _.isArray(proppedSelections) ? [ ...proppedSelections ] : [];
            if (_.findIndex(updatedSelections, [idKey, itemsSelected[idKey]])>=0) {
                updatedSelections = _.filter(updatedSelections, item => item[idKey] !== itemsSelected[idKey]);
            } else {
                updatedSelections = [ ...updatedSelections, itemsSelected];
            }
            onChange(updatedSelections);
        } else {
            onChange(itemsSelected);
        }
    }

    onSelectAll = () => {
        const { selectionType, idKey, selections, flatOptions, onChange, options, value, withInputBox, optionsDisabled } = this.props;
        const proppedSelections = !_.isUndefined(selections) ? selections : value;
        if (selectionType=='id'&&withInputBox) {
			if (options?.length==Object.keys(selections || {}).length) {
				onChange({});
			} else {
				let updatedSelections = _.reduce(options, (acc, item) => {
					acc[item[idKey]] = selections && item[idKey] in selections ? selections[item[idKey]] : 90;
					return acc
				}, []);
				updatedSelections = {...updatedSelections, ...selections};
				onChange(updatedSelections)
			}
        } else if (selectionType=='id') {
			let updatedSelections = _.isArray(proppedSelections) ? [ ...proppedSelections ] : [];
			const allSelected = !_.isUndefined(flatOptions) ?
				updatedSelections?.length == _.filter(flatOptions, opt => !_.includes(optionsDisabled, opt[idKey])).length :
				_.filter(options, opt => !_.includes(optionsDisabled, opt[idKey])).length == updatedSelections?.length;
            if (allSelected) {
                onChange([]);
            } else {
				let disabledOpt = !_.isUndefined(optionsDisabled) ? optionsDisabled : [];
                let updatedSelections = _.flatMap(options, item => {
					const ids = [];
					if (!_.includes(disabledOpt, item[idKey])){
						ids.push(item[idKey]);
					}
					if (item.children && _.isArray(item.children)) {
						const childIds = item.children
							.filter(child => !disabledOpt.includes(child[idKey]))
							.map(child => child[idKey]);
						ids.push(...childIds);
					}
					return ids;
				});
                onChange(updatedSelections);
            }
        } else if (selectionType=='object') {
			let updatedSelections = _.isArray(proppedSelections) ? [ ...proppedSelections ] : [];
			const allSelected = !_.isUndefined(options) ? updatedSelections?.length == _.filter(options, opt => !_.includes(optionsDisabled, opt[idKey])).length : false;
			if (allSelected) {
				onChange([]);
			} else {
				let disabledOpt = !_.isUndefined(optionsDisabled) ? optionsDisabled : [];
				let updatedSelections = _.flatMap(options, item => {
					const items = [];
					if (!_.includes(disabledOpt, item[idKey])) {
						items.push(item);
					}
					return items;
				});
				onChange(updatedSelections);
			}
		}
    }

    onSearch = value => {
        this.setState({ search: value });
    }

    onPopoverChange = (value) => {
		const { popoverStaysOpened } = this.props;
		if (popoverStaysOpened) return;
        if (value) this.setState({ popoverOpened: true });
        else this.setState({ popoverOpened: false });
    }

    renderCheckbox = condition => {
        return condition ? <span className='material-icons' style={{ color: '#346abb' }}>check_box</span> :
            <span className='material-icons'>check_box_outline_blank</span>;
    }

	renderCircleCheckbox = condition => {
		return condition ? <span className='material-icons' style={{ color: '#346abb' }}>radio_button_checked</span> :
            <span className='material-icons'>radio_button_unchecked</span>;
	}

	renderDeselectIcon = () => {
		const { onChange } = this.props;
		return <span className='material-symbols-outlined' onClick={() => onChange(undefined)}>close</span>;
	}

	renderExpandIcon = () => {
		return <span className='material-symbols-outlined'>unfold_more</span>;
	}

	renderTitle = () => {
		const { selectorTitle, showCountInTitle, selections, titleBySelection, idKey, options, titleKey, value, emptyTitle } = this.props;
		const proppedSelections = (!_.isUndefined(selections) && !_.isNull(selections)) ? selections : value;

		// Show count in title if enabled
		if (showCountInTitle && (value || proppedSelections) && selections && !_.isEmpty(selections)) {
			let selectionsCount = 1;
			if (_.isArray(proppedSelections)) {
				selectionsCount = proppedSelections.length;
			} else if (checkPureObject(proppedSelections)) {
				selectionsCount = Object.keys(proppedSelections).length;
			}
			if (selectionsCount > 0) {
				return <span className='ellipsis-overflow'>{selectorTitle} ({selectionsCount})</span>;
			}
		}

		// Show title by selection
		if (titleBySelection) {
			let selectedItem;
			// Array (multiselect) case
			if (_.isArray(proppedSelections)) {
				const first = proppedSelections[0];

				// 1. Custom object with titleKey
				if (_.isObject(first) && titleKey in first) {
					return <span className='ellipsis-overflow'>{first[titleKey]}</span>;
				}

				// 2. Primitive (number/string) that exists in options
				selectedItem = _.find(options, [idKey, first]);

				// 3. Primitive that is custom text stored directly
				if (!selectedItem && _.isString(first)) {
					return <span className='ellipsis-overflow'>{first}</span>;
				}
			}
			// Object (single-select) case
			else if (_.isObject(proppedSelections) && titleKey in proppedSelections) {
				return <span className='ellipsis-overflow'>{proppedSelections[titleKey]}</span>;
			}
			// Primitive (number/string) single-select
			else {
				selectedItem = _.find(options, [idKey, proppedSelections]);
				if (!selectedItem && (typeof proppedSelections === 'string' || typeof proppedSelections === 'number')) {
					return <span className='ellipsis-overflow'>{proppedSelections}</span>;
				}
			}

			// Render normal option
			if (selectedItem?.icon) {
				return (
					<div className='row-vertical-align of-auto'>
						{selectedItem.icon}
						<span className='ellipsis-overflow'>{selectedItem[titleKey]}</span>
					</div>
				);
			}

			return <span className='ellipsis-overflow'>{selectedItem ? selectedItem[titleKey] : emptyTitle || 'No Option Selected'}</span>;
		}

		// Fallback
		return <span className='ellipsis-overflow'>{selectorTitle}</span>;
	};


	renderChevron = () => {
		const { showChevron, chevronSize } = this.props;
		const { popoverOpened } = this.state;
		return !showChevron ? null : popoverOpened ?
                    <span className='ml-5'><IconContext.Provider value={{ style: { verticalAlign: 'middle', fontSize: chevronSize } }}><FaChevronUp/></IconContext.Provider></span> :
                    <span className='ml-5'><IconContext.Provider value={{ style: { verticalAlign: 'middle', fontSize: chevronSize } }}><FaChevronDown/></IconContext.Provider></span>
	}

}

export default GenericSelector;
